import {useEffect, useState} from "react";
import {isNullOrUndefined} from "../../../services/Validator";
import {computePictureUrl} from "../../../controllers/flashScreens/questionsStepScreen/QuestionPictureController";
import SystemAppContentError from "../../errors/SystemAppContentError";
import SystemAppContentLoader from "../../loaders/SystemAppContentLoader";
import {kSystemIcons} from "../../../constants/icons";

export default function LevelAExamplePicture({pictureUrl, openZoom}) {
    // Used in LevelAExampleQuestion to display eventually Knowledge
    // example picture

    // PROPERTIES
    // ---- UX
    const [hasError, setHasError] = useState(false);
    const [isHovered, setIsHovered] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [src, setSrc] = useState(null)

    // HOOKS
    useEffect(() => {
        if (!isNullOrUndefined(pictureUrl)) {
            // Reset state : Loader, error and src
            setSrc(null)
            setIsLoading(true)
            setHasError(false)
            // Prepare
            const url = computePictureUrl(pictureUrl)
            // Execute
            fetch(url).then((res) => {
                res.blob().then((res) => {
                    setSrc(URL.createObjectURL(res))
                }).catch((err) => {
                    console.log(err)
                    setHasError(true)
                })
            }).catch((err) => {
                console.log(err)
                setHasError(true)
            }).finally(() => {
                setIsLoading(false)
            })
        }
    }, [pictureUrl])

    // BUILD
    if (isNullOrUndefined(pictureUrl))
        return null
    if (hasError)
        return <SystemAppContentError />
    if (isLoading)
        return <SystemAppContentLoader />
    return (
        <div className="mt-[16px] bg-white w-full flex justify-center items-center
             animate-appear relative cursor-pointer overflow-hidden rounded-[8px]"
             onMouseEnter={() => setIsHovered(true)}
             onMouseLeave={() => setIsHovered(false)}
             onClick={openZoom} >
            <img src={src}
                 alt="Illustration"
                 className={"object-contain max-h-[280px] w-auto"}
                 onError={() => setHasError(true)}
                 onLoad={() => setHasError(false)} />
            <div className={`animate-appearFast ${(isHovered) ? 'absolute bottom-0 left-0 w-full h-[32px] bg-gradient-to-t from-backgroundLight1/80 to-transparent opacity-100' : 'opacity-0'}`}></div>
            <div className={`animate-appearFast ${(isHovered) ? "flex justify-center items-center absolute bottom-[2px] right-[4px]" : "hidden"}`}>
                <i className={`material-icons text-[24px] text-white`}>
                    {kSystemIcons.zoomIn}
                </i>
            </div>
        </div>
    );
}